import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import ClientLayout from '../../components/ClientLayout';
import { useNavigate } from 'react-router-dom';

const COLORS = {
    green: '#2E5B2E',
    pink: '#C19A6B',
    cream: '#F9F9F5',
    dark: '#333333',
    white: '#FFFFFF',
    gray: '#E5E7EB',
    danger: '#DC2626'
};

const PRECIOS_LABELS = {
    precio_cafe_americano: 'Café Americano Standard',
    precio_especialidad_chiapas: 'Especialidad Chiapas (Altura)',
    precio_especialidad_guerrero: 'Especialidad Guerrero',
    precio_descafeinado: 'Descafeinado',
    precio_cafe_olla: 'Mezcla Café de Olla',
    precio_cafe_ejecutivo: 'Mezcla Ejecutiva'
};

function MiPerfil() {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [profile, setProfile] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    
    // Datos de Perfil (Restaurante, dirección, etc.)
    const [formData, setFormData] = useState({
        firstName: '', lastName: '', restaurant: '', direction: '', notas: ''
    });

    // Datos de Autenticación (Username, Email, Passwords)
    const [authData, setAuthData] = useState({
        username: '',
        email: '',
        newPassword: '',
        confirmPassword: '',
        currentPassword: '' // Para validar el cambio
    });

    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem('token');
            try {
                const { data } = await api.get('/profile/me', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (data) {
                    setProfile(data);
                    setFormData({
                        firstName: data.firstName || '',
                        lastName: data.lastName || '',
                        restaurant: data.razonSocial || '', 
                        direction: data.direccionFiscal || '', 
                        notas: data.notas || ''
                    });
                    setAuthData(prev => ({...prev, username: data.usuario?.username, email: data.usuario?.email}));
                }
            } catch (error) {
                console.error("Error cargando perfil", error);
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, []);

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
    const handleAuthChange = (e) => setAuthData({ ...authData, [e.target.name]: e.target.value });

    const handleProfileSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        const token = localStorage.getItem('token');
        try {
            const payload = { ...formData };
            const { data } = await api.patch('/profile/me', payload, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setProfile(data);
            alert('✅ Datos de negocio actualizados');
        } catch (error) {
            alert('Error al actualizar perfil');
        } finally {
            setSaving(false);
        }
    };

    const handleUpdateAuth = async (e) => {
        e.preventDefault();
        if (authData.newPassword && authData.newPassword !== authData.confirmPassword) {
            return alert("❌ Las contraseñas nuevas no coinciden");
        }
        if (!authData.currentPassword) return alert("⚠️ Debes ingresar tu contraseña actual");

        const token = localStorage.getItem('token');
        setSaving(true);
        try {
            const payload = {
                username: authData.username,
                email: authData.email,
                password: authData.newPassword || undefined,
                currentPassword: authData.currentPassword // El backend debe validar esto
            };

            await api.patch('/users/update-auth', payload, {
                headers: { Authorization: `Bearer ${token}` }
            });

            alert('✅ Datos de acceso actualizados correctamente');
            setShowModal(false);
            if (authData.newPassword) {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } catch (error) {
            alert(error.response?.data?.message || 'Error de validación');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div style={{ textAlign: 'center', padding: 50 }}>Cargando perfil...</div>;

    return (
        <ClientLayout title="Mi Perfil de Negocio">
            <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', gap: 30, flexWrap: 'wrap' }}>
                
                {/* 1. DATOS DE NEGOCIO */}
                <div style={cardStyle}>
                    <h3 style={headerStyle}>📦 Datos de Contacto y Facturación</h3>
                    <form onSubmit={handleProfileSubmit}>
                        <div style={{ display: 'flex', gap: 15, marginBottom: 15 }}>
                            <div style={{ flex: 1 }}>
                                <label style={labelStyle}>Nombre</label>
                                <input name="firstName" style={inputStyle} value={formData.firstName} onChange={handleChange} />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={labelStyle}>Apellido</label>
                                <input name="lastName" style={inputStyle} value={formData.lastName} onChange={handleChange} />
                            </div>
                        </div>
                        <div style={groupStyle}><label style={labelStyle}>Razón Social</label><input name="restaurant" style={inputStyle} value={formData.restaurant} onChange={handleChange} /></div>
                        <div style={groupStyle}><label style={labelStyle}>Dirección</label><input name="direction" style={inputStyle} value={formData.direction} onChange={handleChange} /></div>
                        <div style={groupStyle}><label style={labelStyle}>Notas</label><textarea name="notas" style={{ ...inputStyle, height: 60 }} value={formData.notas} onChange={handleChange} /></div>
                        <button type="submit" disabled={saving} style={btnStyle}>Guardar Datos de Negocio</button>
                    </form>
                </div>

                {/* 2. SEGURIDAD Y ACCESO */}
                <div style={cardStyle}>
                    <h3 style={headerStyle}>🔐 Seguridad y Acceso</h3>
                    <div style={groupStyle}><label style={labelStyle}>Usuario</label><input name="username" style={inputStyle} value={authData.username} onChange={handleAuthChange} /></div>
                    <div style={groupStyle}><label style={labelStyle}>Correo Electrónico</label><input name="email" style={inputStyle} value={authData.email} onChange={handleAuthChange} /></div>
                    <div style={groupStyle}><label style={labelStyle}>Nueva Contraseña (Opcional)</label><input type="password" name="newPassword" style={inputStyle} placeholder="Dejar en blanco para no cambiar" onChange={handleAuthChange} /></div>
                    {authData.newPassword && (
                        <div style={groupStyle}><label style={labelStyle}>Confirmar Nueva Contraseña</label><input type="password" name="confirmPassword" style={inputStyle} onChange={handleAuthChange} /></div>
                    )}
                    <button onClick={() => setShowModal(true)} style={{ ...btnStyle, background: COLORS.dark }}>Actualizar Credenciales</button>
                </div>

                {/* 3. PRECIOS (DERECHA) */}
                <div style={{ flex: '1 1 300px' }}>
                    <div style={{ background: COLORS.green, color: COLORS.white, padding: 25, borderRadius: 12 }}>
                        <h3 style={{ marginTop: 0 }}>💲 Precios Pactados</h3>
                        {Object.entries(PRECIOS_LABELS).map(([key, label]) => {
                            const precio = Number(profile?.[key]) || 0;
                            if (precio <= 0) return null; 
                            return (
                                <div key={key} style={priceRowStyle}>
                                    <span>{label}</span>
                                    <span style={{ fontWeight: 'bold' }}>${precio.toFixed(2)}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* MODAL DE VALIDACIÓN */}
            {showModal && (
                <div style={modalOverlayStyle}>
                    <div style={modalContentStyle}>
                        <h3 style={{ color: COLORS.green }}>Confirmar Cambios</h3>
                        <p style={{ fontSize: 14, color: '#666' }}>Por seguridad, ingresa tu <b>contraseña actual</b> para modificar tus datos de acceso.</p>
                        <input 
                            type="password" 
                            name="currentPassword" 
                            placeholder="Tu contraseña actual" 
                            style={inputStyle} 
                            onChange={handleAuthChange} 
                        />
                        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                            <button onClick={() => setShowModal(false)} style={cancelBtnStyle}>Cancelar</button>
                            <button onClick={handleUpdateAuth} disabled={saving} style={confirmBtnStyle}>Confirmar y Guardar</button>
                        </div>
                    </div>
                </div>
            )}
        </ClientLayout>
    );
}

// Estilos adicionales
const cardStyle = { flex: '1 1 450px', background: COLORS.white, padding: 30, borderRadius: 12, boxShadow: '0 4px 10px rgba(0,0,0,0.05)' };
const headerStyle = { color: COLORS.green, borderBottom: `1px solid ${COLORS.cream}`, paddingBottom: 10, marginTop: 0 };
const groupStyle = { marginBottom: 15 };
const labelStyle = { display: 'block', marginBottom: 5, fontWeight: 'bold', color: COLORS.dark, fontSize: 13 };
const inputStyle = { width: '100%', padding: 12, borderRadius: 8, border: `1px solid ${COLORS.gray}`, fontSize: 14, background: COLORS.cream, boxSizing: 'border-box' };
const btnStyle = { width: '100%', padding: 12, background: COLORS.pink, color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 'bold', cursor: 'pointer' };
const priceRowStyle = { display: 'flex', justifyContent: 'space-between', marginBottom: 10, borderBottom: '1px dashed rgba(255,255,255,0.2)', paddingBottom: 5, fontSize: 13 };

// Estilos del Modal
const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 };
const modalContentStyle = { background: 'white', padding: 30, borderRadius: 15, width: '90%', maxWidth: 400, textAlign: 'center' };
const cancelBtnStyle = { flex: 1, padding: 10, background: '#eee', border: 'none', borderRadius: 8, cursor: 'pointer' };
const confirmBtnStyle = { flex: 1, padding: 10, background: COLORS.green, color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer' };

export default MiPerfil;